module.exports = __webpack_public_path__ + "img/QCOM.OQ.35b9489f.png";